export default `
  mutation SendGuestWishlist($guestCustomerId: ID!, $name: String!, $email: String!, $emails: String!, $message: String!) {
    sendGuestWishlist(guestCustomerId: $guestCustomerId, name: $name, email: $email, emails: $emails, message: $message) {
      status
      errors
      sent_emails
    }
  }
`;
